module.exports = __webpack_public_path__ + "img/win-stencil.231c5efa.svg";